<template>
  <ShopHeader />
  <ContentWrap>
    <ul class="goods-list clearfix">
      <li v-for="item in goodList" :key="item.id">
        <router-link :to="{ path: '/goodInfo', query: { goodsId: item.id } }" target="_blank">
          <div class="image">
            <img :src="item.img" alt="开通轻会员" />
          </div>
          <div class="title">{{ item.title }}</div>
          <span class="price">￥ {{ item.price/100 }}</span>
        </router-link>
      </li>
    </ul>
  </ContentWrap>
</template>

<script>
import goodList from './goodList'
import ShopHeader from '../Layout/shopHeader.vue'
import ContentWrap from '../Layout/contentWrap.vue'
export default {
  components: {
    ShopHeader,
    ContentWrap
  },
  data() {
    return {
      goodList
    }
  }
}
</script>

<style>
.goods-list {
  margin-top: 30px;
}

.goods-list li {
  width: 235px;
  height: 330px;
  float: left;
  margin: 0 20px 20px 0;
  background-color: #fff;
}

.goods-list li a {
  display: block;
  width: 235px;
  height: 330px;
  font-size: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.goods-list li .image {
  width: 235px;
  height: 235px;
  background: url('data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAC1JREFUeNpi+P//PwMMP3369AUyH1mMKEVwhYQUgRUSowjFakJOYBhOngEIMAB1izbs6IM8DAAAAABJRU5ErkJggg==')
    repeat scroll 0 0;
  position: relative;
}

@media (-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx) {
  .goods-list li .image {
    background-image: url('data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHtJREFUeNrk0z0OgDAIhuH+XMJw/7M1XsKgGG2qQgf4NllYyJMOfTMzJ21aa6tsIlrSZI677bqrsgsSU8EI9gGj2ANEYB1EYSeIxPoLUZjcZesfejDzH3oxuStIbFaKC7NKcWNaKSHsXUoYG0uBYHcpMGwspf6nlF2AAQDfXKiQ9cotVQAAAABJRU5ErkJggg==');
    background-size: 10px 12px;
  }
}

.goods-list li .image img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 235px;
  max-height: 235px;
}

.goods-list li .title {
  color: #333;
  padding: 20px 15px 0;
  margin-bottom: 10px;
  line-height: 1.5em;
  height: 38px;
  overflow: hidden;
}

.goods-list li .price {
  color: #f60;
  padding: 0 0 0 15px;
}

.goods-list li .origin-price {
  color: #666;
}

.goods-list li:nth-child(4n) {
  margin-right: 0;
}

@media screen and (min-width: 1160px) {
  .goods-list li {
    width: 275px;
    height: 375px;
  }

  .goods-list li a {
    width: 275px;
    height: 375px;
  }

  .goods-list li .image {
    width: 275px;
    height: 275px;
  }

  .goods-list li .image img {
    max-width: 275px;
    max-height: 275px;
  }
}
</style>
